import React from "react";
import { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import MainLayout from "../layouts/MainLayout";
import { Button } from "../components/Button/Button";
import ShadowCard from "../components/ShadowCard/ShadowCard";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../utils/base_url";
import Solo_PractitionersTop from "../components/Solo_PractitionersTop/Solo_PractitionersTop";
import Solo_practitionersSecond, {
  SoloPractitionersSecond,
} from "../components/Solo_PractitionersSecond/Solo_practitionersSecond";
import { useMediaQuery } from "react-responsive";

import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _2200px,
  _576px,
  _768px,
  _992px,
} from "../utils/mediaBreakpoints";
import Solo_PractitionersTopUpdated from "../components/Solo_PractitionersTop/Solo_PractitionersTopUpdated";

const MainJudges_LawClerks = ({ data, isMobile }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const _2200 = useMediaQuery({ maxWidth: _2200px });
  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid m-0 p-0 ">
        <div className="row">
          {/* <div
            className="col-12"
            style={{
              backgroundImage: "linear-gradient(to bottom , #000000, #459EFF)",
            }}
          >
            <Solo_PractitionersTop
              heading={data?.new_hero?.heading}
              subHeading={data?.new_hero?.sub_heading}
              btntext={data?.new_hero?.CTA?.text}
              btnbg={data?.new_hero?.CTA?.backgroundColor}
              btnclr={data?.new_hero?.CTA?.textColor}
              btnurl={data?.new_hero?.CTA?.url}
              imgsrc1={`${baseUrl}${data?.new_hero?.images[0]?.url}`}
              imgsrcs={data?.new_hero?.images}
              imgsrc2={`${baseUrl}${data?.new_hero?.images[1]?.url}`}
              imgsrc3={`${baseUrl}${data?.new_hero?.images[2]?.url}`}
              isMobile={isMobile}
              toppadding={"3rem"}
              texttopmargin={"4.5rem"}
              headingfs={"fs70"}
              headinglh={"4.2rem"}
            />
          </div> */}
          <div className="col-12">
            <Solo_PractitionersTopUpdated
              leftbg={data?.column_view?.column_childs[0]?.backgroundColor}
              heading={data?.column_view?.column_childs[0]?.heading}
              subHeading={data?.column_view?.column_childs[0]?.sub_heading}
              imgsrc={data}
            />
          </div>

          {/* <div className="col-12">
            <Solo_practitionersSecond
              rightbg={" #283950"}
              leftbg={" #1F46BE"}
              mainclassleft={`col-12 col-lg-6 d-flex flex-column justify-content-center justify-content-lg-end align-items-center align-items-lg-end ${
                isMobile ? "px-4" : ""
              }`}
              mainclassright={"d-none d-lg-block col-lg-6 "}
              leftheading={data?.column_view?.column_childs[0]?.heading}
              leftsubheading={data?.column_view?.column_childs[0]?.sub_heading}
              isMobile={isMobile}
            />
          </div>
          <div className="col-12">
            <Solo_practitionersSecond
              rightbg={" #090D24"}
              leftbg={" #283950"}
              mainclassleft={"d-none d-lg-block col-lg-6"}
              mainclassright={`col-12 col-lg-6 d-flex flex-column justify-content-center justify-content-lg-end align-items-end ${
                isMobile ? "px-4" : ""
              }`}
              rightheading={data?.column_view?.column_childs[1]?.heading}
              rightsubheading={data?.column_view?.column_childs[1]?.sub_heading}
              isMobile={isMobile}
            />
          </div>
          <div className="col-12">
            <Solo_practitionersSecond
              rightbg={" #283950"}
              leftbg={" #1F46BE"}
              mainclassleft={`col-12 col-lg-6 d-flex flex-column justify-content-center justify-content-lg-end align-items-center align-items-lg-end ${
                isMobile ? "px-4" : ""
              }`}
              mainclassright={"d-none d-lg-block col-lg-6 "}
              leftheading={data?.column_view?.column_childs[2]?.heading}
              leftsubheading={data?.column_view?.column_childs[2]?.sub_heading}
              isMobile={isMobile}
            />
          </div> */}

          {data?.column_view?.column_childs?.slice(1)?.map((item, index) => (
            <div className="col-12 ">
              <SoloPractitionersSecond
                staticBg={" #283950"}
                bg={item?.backgroundColor}
                // mainclassleft={`${item?.left_col}  ${isMobile ? "" : ""}`}
                // mainclassright={`d-none d-lg-block ${item?.right_col}`}
                mainclassleft={`col-lg-6 col-12  ${isMobile ? "" : ""}`}
                mainclassright={`d-none d-lg-block col-lg-6 col-12`}
                imgsrc={item?.image}
                heading={item?.heading}
                subheading={item?.sub_heading}
                // left={index % 2 === 0}
                left={_992 ? true : index % 2 === 0}
                isMobile={isMobile}
              />
            </div>
          ))}

          <div className="col-12" style={{ backgroundColor: " #090D24" }}>
            <div className="container contwidth ">
              <p
                dangerouslySetInnerHTML={{
                  __html: data?.outcomes?.text
                    ?.replace(/\n/g, "<br/>")
                    ?.replace(
                      /reduce administrative burdens/gi,
                      '<span style="color: #459EFF;">reduce administrative burdens</span>'
                    )
                    ?.replace(
                      /ensure accurate rulings./gi,
                      '<span style="color: #459EFF;">ensure accurate rulings.</span>'
                    ),
                }}
                className={`text-white ${
                  isMobile ? "fs30 " : ""
                } fw500 text-center`}
                style={{
                  padding: "5rem 0",
                  color: "white",
                  fontSize: _768
                    ? "20px"
                    : _992
                    ? "25px"
                    : _1200
                    ? "25px"
                    : _1400
                    ? "35px"
                    : _1500
                    ? "40px"
                    : _1600
                    ? "40px"
                    : _1700
                    ? "40px"
                    : _1800
                    ? "40px"
                    : "45px",
                  fontWeight: "500",
                }}
              ></p>
            </div>
          </div>

          <div
            className="col-12"
            style={{
              height: "vh-100",
              background:
                "linear-gradient(to bottom, #1F46BE 0%, #1F46BE 32%, #090D24 32%, #090D24 100%)",
            }}
          >
            <div className="container contwidth" style={{ padding: "5rem 0" }}>
              <div className={`row gy-5 gy-md-0 ${isMobile ? "px-4" : "px-0"}`}>
                {data?.info_cards?.details?.map((card, index) => {
                  return (
                    <>
                      <div
                        onClick={() => navigate("/product-overview")}
                        key={index}
                        className={`cursor-pointer col-12 col-lg-4 col-md-6 d-flex ${
                          _992
                            ? " justify-content-center"
                            : index === 0
                            ? "justify-content-start"
                            : index === 1
                            ? "justify-content-center"
                            : index === 2
                            ? "justify-content-end"
                            : ""
                        }`}
                      >
                        <ShadowCard
                          isCrdWhite={true}
                          // background={card?.backgroundColor}
                          topHeading={card?.heading}
                          text={card?.sub_heading}
                          topIcon={card?.top_icon?.url}
                          lineColor={card?.horizontal_line_color}
                          textClass={`fw400 ${
                            _576
                              ? "fs18"
                              : _768
                              ? "fs20"
                              : _992
                              ? "fs18"
                              : _1200
                              ? "fs18"
                              : _1400
                              ? "fs16"
                              : _1500
                              ? "fs16"
                              : _1600
                              ? "fs16"
                              : _1700
                              ? "fs18"
                              : _1800
                              ? "fs18"
                              : "fs20"
                          }`}
                          headingClass={`fw800 ${
                            _576
                              ? "fs23"
                              : _768
                              ? "fs20"
                              : _992
                              ? "fs25"
                              : _1200
                              ? "fs25"
                              : _1400
                              ? "fs26"
                              : _1500
                              ? "fs28"
                              : _1600
                              ? "fs28"
                              : _1700
                              ? "fs32"
                              : _1800
                              ? "fs35"
                              : "fs35"
                          } `}
                          topIConHeight={card?.top_icon?.height}
                          topIConWidth={card?.top_icon?.width}
                          // bottomCorner={card?.right_corner_color}
                        />
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Judges_LawClerks = ({ isMobile }) => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=judges-and-law-clerks",
      setPageData,
      setLoader
    );
  }, []);
  return (
    <>
      <MainLayout loader={loader}>
        <div className="container-fluid  p-0 overflow-x-hidden">
          <MainJudges_LawClerks data={pageData} isMobile={isMobile} />
        </div>
      </MainLayout>
    </>
  );
};

export default Judges_LawClerks;
